import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Autorenew from 'material-ui/svg-icons/action/autorenew'
import constants from './constants'
import styles from './styles/booking.css'
import AlertIcon from '../../assets/AlertIcon'

class Booking extends Component {
  static propTypes = {
    booking: PropTypes.shape({
      appointment_type_ids: PropTypes.arrayOf(PropTypes.string),
      automation: PropTypes.bool.isRequired,
      booked_chairs: PropTypes.number.isRequired,
      booking_patients: PropTypes.arrayOf(PropTypes.object),
      chairs: PropTypes.number.isRequired,
      cloud9_booking_id: PropTypes.number,
      colIndex: PropTypes.number.isRequired,
      created_at: PropTypes.string.isRequired,
      doctor_id: PropTypes.string.isRequired,
      doctors: PropTypes.object,
      end: PropTypes.shape({
        format: PropTypes.func.isRequired,
      }).isRequired,
      external_id: PropTypes.string,
      from_pms: PropTypes.bool.isRequired,
      id: PropTypes.number.isRequired,
      length: PropTypes.number.isRequired,
      location_id: PropTypes.string.isRequired,
      locations: PropTypes.object,
      numCols: PropTypes.number.isRequired,
      recurring: PropTypes.bool.isRequired,
      recurring_booking_id: PropTypes.number,
      start: PropTypes.shape({
        format: PropTypes.func.isRequired,
      }).isRequired,
      start_datetime: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      updated_at: PropTypes.string.isRequired,
    }).isRequired,
    handleBookingClick: PropTypes.func.isRequired,
    topOffset: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)
    const {
      booking: { status },
    } = props
    this.state = {
      hovered: false,
      reservedBooking: status === 'reserved',
    }
  }

  setHovered = () => {
    if (length < 60) {
      this.setState({ hovered: true })
    }
  }

  unSetHovered = () => {
    if (length < 60) {
      this.setState({ hovered: false })
    }
  }

  render() {
    const {
      booking,
      booking: {
        automation,
        booked_chairs: bookedChairs,
        chairs,
        colIndex,
        doctor_id: doctorId,
        length,
        location_id: locationId,
        numCols,
        recurring,
        start,
      },
      doctors,
      handleBookingClick,
      locations,
      topOffset,
    } = this.props
    const { reservedBooking } = this.state
    const { minHourHeight, numHours } = constants
    const { hovered } = this.state

    const locName = locations[locationId].name
    const doctor = doctors[doctorId]
    const {
      preferred_name: preferredName,
      first_name: firstName,
      last_name: lastName,
    } = doctor

    const doctorName = preferredName || `${firstName} ${lastName}`

    const bookingChairs = Array.from({ length: chairs }, (_, index) => {
      if (index < bookedChairs) return cx(styles.chairSquare, styles.chairSquareBooked)
      return styles.chairSquare
    })

    const bookingContainerStyle = {
      left: `calc( ((100% / 7) * ${start.day()}) + (((100% / 7) / ${numCols}) * ${colIndex}) + 2px )`,
      height: `calc( 
        (${start.hour() - topOffset} * (100vh - 140px) / ${numHours}) 
        + ( ${start.minute() / 15} * ( (100vh - 140px) / ${numHours * 4} ) )
        + ( ${length / 15} * ( (100vh - 140px) / ${numHours * 4} ) )
        + 80px 
      )`,
      minHeight: `calc( 
        (${start.hour() - topOffset} * ${minHourHeight}) 
        + ( ${start.minute() / 15} * ( ${minHourHeight} / 4 ) )
        + ( ${length / 15} * ( ${minHourHeight} / 4 ) )
        + 80px 
      )`,
      width: 'calc(100% / 7)',
    }

    const bookingInlineStyles = {
      minHeight: `calc( (${minHourHeight} / 4) * ${
        hovered ? 4 : length / 15
      } - 2px)`,
      height: `calc( ( (100vh - 140px)/${numHours} / 4) * ${
        length / 15
      } - 3px)`,
      width: `calc( (100%  / ${numCols}) - 3px )`,
    }

    const bookingStyles = cx(styles.booking, {
      [styles.bookingAutomation]: automation,
      [styles.reserved]: reservedBooking,
    })

    return (
      <div className={styles.bookingContainer} style={bookingContainerStyle}>
        <div
          className={bookingStyles}
          style={bookingInlineStyles}
          onMouseEnter={this.setHovered}
          onMouseLeave={this.unSetHovered}
          onClick={(e) => {
            handleBookingClick(e, booking, false)
          }}
          role="button"
          tabIndex="0"
        >
          <div className={styles.times}>
            {`${start.format('h:mma')} - ${start
              .clone()
              .add(length, 'm')
              .format('h:mma')}`}
          </div>
          <div className={styles.doctor}>{doctorName}</div>
          <div className={styles.location}>{locName}</div>
          <div className={styles.chairLine}>
            {bookingChairs.map((chairClass, index) => (
              <div className={chairClass} key={`${index * 4}${chairClass}`} />
            ))}
            <span className={styles.chairIndicator}>
              {`${bookedChairs}/${chairs}`}
            </span>
          </div>
          {reservedBooking && (
            <div className={styles.recurringIcon}>
              <AlertIcon />
            </div>
          )}
          {automation && !reservedBooking && (
            <div title="Automation Booking" className={styles.recurringIcon}>
              A
            </div>
          )}
          {recurring && <Autorenew className={styles.recurringIcon} />}
        </div>
      </div>
    )
  }
}

export default Booking



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/Booking.js